export default __webpack_public_path__ + "static/Capgemini_Logo_Color_RGB-4947779315b5a83a7ab95a325ab24eed.png";